import { EpocusRole } from "elephant-web/gql";

const ROLE_LABELS: Record<EpocusRole, string> = {
  [EpocusRole.Performer]: "Performer",
  [EpocusRole.Reviewer]: "Reviewer",
  [EpocusRole.PerformerReviewer]: "Performer + Reviewer",
  [EpocusRole.QaAdmin]: "QA Admin",
  [EpocusRole.ProgramAdmin]: "Program Admin",
};

export const roleLabel = (role: EpocusRole): string => ROLE_LABELS[role];
